import React, { Component } from 'react'
import EventEmitter from 'chirashi-event-emitter'
import { noop } from 'lodash'
import { renderComponent } from 'recompose'

const apiLoaderFactory = () => {
  const emitter = EventEmitter()

  const fetching = []
  const loaded = []

  return {
    load: (api) => {
      if (loaded.includes(api)) {
        return Promise.resolve()
      }

      if (!fetching.includes(api)) {
        const tag = document.createElement('script')
        Object.assign(tag, {
          async: true,
          src: api
        })

        document.body.appendChild(tag)

        tag.addEventListener('load', () =>
          emitter.emit(`loaded:${api}`)
        )
      }

      return new Promise(resolve => {
        emitter.on(`loaded:${api}`, resolve)
      })
    }
  }
}

const apiLoader = apiLoaderFactory()

export default (src, loading = null) => WrappedComponent => (
  class EnsureApi extends Component {
    state = {
      apiLoaded: false
    }

    componentDidMount () {
      apiLoader
        .load(src)
        .then(() => {
          this.setState({ apiLoaded: true })
        })
    }

    render () {
      return this.state.apiLoaded
        ? <WrappedComponent {...this.props} />
        : loading
    }
  }
)



// WEBPACK FOOTER //
// ./src/hoc/withScript.js